module.exports = __webpack_public_path__ + "media/barometer_linkedin/header-wave-1fb30c69.png";